import * as React from "react";
const SvgLine = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 349, height: 3, fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { stroke: "#D5D7DD", strokeDasharray: "0 13", strokeLinecap: "square", strokeWidth: 3, d: "M1.5 1.5h352" }));
export default SvgLine;
